import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { CobranzasService } from 'app/services/cobranzas/cobranzas.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pagos-detalle',
  templateUrl: './pagos-detalle.component.html',
  styleUrls: ['./pagos-detalle.component.scss']
})
export class PagosDetalleComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  loading = false;
  dataSource = new MatTableDataSource;
  datadetalle: any = [];
  dataCobranza: any = this.cobranzasService.dataCobranza
  sumaTotal:any = 0;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() cerrarDetalle = new EventEmitter<boolean>();

  pageSizeOptions = [10,20,30,50,100,200];
  displayedColumns: string[] = 
  ['Serie','idCuotas','Fecha_de_Pago','Estado_Desc','Total_Cuota','Importe_Ajuste','Importe_Pendiente','Importe'];

  constructor(private cobranzasService: CobranzasService) { }

  ngOnInit() {
    this.ObtenerPagosDetalle();
  }

  CerrarPopUp() {
    this.cobranzasService.dataCobranza=[];
    this.cerrarDetalle.emit();
  }

  ObtenerPagosDetalle() {
    this.loading = true;
    this.cobranzasService.ObtenerCobranzaDetalle(this.dataCobranza.idCobranza).subscribe(
      res => {
        this.datadetalle = res;
        this.datadetalle.forEach(element => {
          this.sumaTotal+=Number(element.Importe);
          if(element.Importe_Pendiente<0){
            element.Importe_Pendiente = 0
          }
          console.log(element);
        });
        this.dataSource = new MatTableDataSource(this.datadetalle);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      }, err => {
        Swal.fire({
          title: "¡Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.loading = false;
      }
    )
  }
}
